// extracted by mini-css-extract-plugin
export default {"DogmaDetailsTable":"qM4DnofwFTQ58MemDBxX","DogmaDetailsFootPrintContainerTable":"u9I6L5XHzAsc27y1Q7fF"};